/**
 * Resolve a product image path to something this app can actually load.
 *
 * The catalogue holds two kinds of image reference:
 *
 *   /assets/images/products/…    a path relative to the STOREFRONT's web root,
 *                                for the imagery carried over from the old site
 *   https://…supabase.co/…       a full URL, for anything uploaded here
 *
 * The admin panel is served from a different origin from the shop — a separate
 * port in development, a separate Netlify site in production — so a root-relative
 * path resolves against the admin's own origin and 404s. Prefixing the storefront
 * origin is what makes the thumbnails appear.
 *
 * Set VITE_STOREFRONT_URL per environment; it defaults to the local dev server.
 */

const STOREFRONT_ORIGIN = (import.meta.env.VITE_STOREFRONT_URL || 'http://localhost:5173').replace(/\/$/, '')

export function productImageUrl(src) {
  if (!src) return null
  // Already absolute — an upload, or an external URL. Leave it alone.
  if (/^(https?:)?\/\//i.test(src) || src.startsWith('data:')) return src
  return `${STOREFRONT_ORIGIN}${src.startsWith('/') ? '' : '/'}${src}`
}

export { STOREFRONT_ORIGIN }
